export const handleFileDownload = (url?: string) => {
  if (!url) return;
  const link = document.createElement("a");
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
